import { Html5Entities } from "html-entities";
import sanitizeHtml from "sanitize-html";

const entities = new Html5Entities();

export const sanitize = (html: string) =>
  sanitizeHtml(entities.decode(html), {
    allowedTags: ["b", "i", "em", "strong", "a", "sub", "sup"],
    allowedAttributes: {
      a: ["href"],
    },
  });

export const totalSanitize = (html: string) =>
  entities.decode(
    sanitizeHtml(html, { allowedTags: [], allowedAttributes: {} })
  );

export const sanitizeCitation = (html: string) => {
  return sanitizeHtml(html, {
    allowedTags: ["b", "i", "em", "strong", "a", "sub", "sup", "div"],
    allowedAttributes: {
      a: ["href"],
      div: ["class"],
    },
  });
};
